import React from 'react';
import Card from '../Card/Card';
import styles from './KPICard.module.css';

/**
 * KPICard — carte KPI réutilisable (Note Google, Satisfaction, etc.)
 *
 * Props :
 *  - id          : id HTML pour le backend (#kpi-note, #kpi-satisfaits, …)
 *  - label       : "Note Google"
 *  - icon        : "⭐"
 *  - value       : "4,7"  (string ou number)
 *  - showStar    : boolean — affiche un ★ doré collé à la valeur
 *  - delta       : "↑ +5 pts"  ou "⟳ Sync Google"
 *  - sub         : "127 avis au total"
 *  - accent      : boolean — fond crème chaud (utilisé pour la note Google)
 *  - valueId     : id sur le span de la valeur (pour update direct DOM)
 */
export default function KPICard({
  id,
  label,
  icon,
  value,
  showStar = false,
  delta,
  sub,
  accent = false,
  valueId,
  onDeltaClick,        // si fourni, le delta devient un bouton cliquable
  deltaLoading = false, // affiche '...' à la place du delta pendant un fetch
}) {
  return (
    <Card
      span={3}
      id={id}
      className={accent ? styles.accent : ''}
    >
      <div className={styles.label}>
        <span>{label}</span>
        {icon && <span className={styles.icon}>{icon}</span>}
      </div>
      <div className={styles.value}>
        <span id={valueId}>{value}</span>
        {showStar && <span className={styles.star}>★</span>}
      </div>
      {delta && (
        onDeltaClick ? (
          <button
            type="button"
            className={`${styles.delta} ${styles.deltaButton}`}
            onClick={onDeltaClick}
            disabled={deltaLoading}
          >
            {deltaLoading ? '⟳ …' : delta}
          </button>
        ) : (
          <div className={styles.delta}>{delta}</div>
        )
      )}
      {sub && <div className={styles.sub}>{sub}</div>}
    </Card>
  );
}
